import { Component, Input, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FilterService } from '../filter.service';

@Component({
  selector: 'kt-f-checkbox',
  templateUrl: './f-checkbox.component.html',
  styleUrls: ['./f-checkbox.component.scss']
})
export class FCheckboxComponent implements OnInit {
  @Input() key: string;
  @Input() label: string;

  value = false;


  constructor(
    private _filterService: FilterService
  ) { }

  ngOnInit(): void {
    this._filterService.reset$.subscribe(() => {
      this._default()
    })
    this._default()
  }

  private _default() {
    this.value = false;
    this._filterService.setValue(this.key, 0)
  }

  onCheckboxChange(event: MatCheckboxChange) {
    this.value = event.checked
    this._filterService.setValue(this.key, this.value ? 1 : 0)
  }

}
